import React from "react";

//apollo imports
import { Query, QueryResult } from "react-apollo";
import gql from "graphql-tag";

//component imports
import Signin from "./pages/signin";
import Dashboard from "./pages/dashboard";
import Loading from "./components/loading/loading";
import Error from "./components/error/error";

const App = () => {
  return (
    <>
      <Query query={IS_LOGGED_IN}>
        {({ data, loading, error }: QueryResult) => {
          if (loading) return <Loading />;
          if (error) return <Error error={error} />;
          return data.isLoggedIn ? <Dashboard /> : <Signin />;
        }}
      </Query>
    </>
  );
};

const IS_LOGGED_IN = gql`
  query IsUserLoggedIn {
    isLoggedIn @client
  }
`;

export default App;
